var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 62,
    viewBox: "0 0 60 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 31C7.99806 30.1904 8.20384 29.394 8.59731 28.6884C8.99079 27.9828 9.55859 27.3919 10.2455 26.9732L52.8146 0.701934C53.5323 0.258575 54.3543 0.0165362 55.1957 0.00081974C56.0371 -0.0149006 56.8674 0.196266 57.6009 0.612518C58.3274 1.0223 58.9326 1.6199 59.3542 2.34387C59.7759 3.06784 59.9988 3.89205 60 4.73174L60 57.2683C59.9988 58.1079 59.7759 58.9322 59.3542 59.6561C58.9326 60.3801 58.3274 60.9777 57.6009 61.3875C56.8674 61.8037 56.0371 62.0149 55.1957 61.9992C54.3543 61.9835 53.5322 61.7414 52.8145 61.2981L10.2455 35.0268C9.55858 34.6081 8.99079 34.0172 8.59731 33.3116C8.20384 32.606 7.99806 31.8096 8.00001 31Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.8478e-07 59.8864C1.6739e-07 60.4469 0.210713 60.9845 0.585785 61.3809C0.960858 61.7773 1.46957 62 2 62C2.53043 62 3.03914 61.7773 3.41421 61.3809C3.78929 60.9845 4 60.4469 4 59.8864L4.00001 2.11364C4.00001 1.55306 3.78929 1.01545 3.41422 0.619068C3.03915 0.222683 2.53044 2.21217e-07 2.00001 1.74846e-07C1.46957 1.28474e-07 0.960864 0.222683 0.585791 0.619068C0.210718 1.01545 5.31606e-06 1.55306 5.23543e-06 2.11364L1.8478e-07 59.8864Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.5334c15b706543efdef5eed75593368f.svg";
export { ForwardRef as ReactComponent };